import React, { Component } from 'react';
import { Card, CardHeader, CardBody, CardFooter, Label, FormGroup } from 'reactstrap';
import { Row, Col, PageHeader, Input, Select, Table, Spin, Tag, Button, Modal } from 'antd';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import Widget02 from '../../components/Ants/Widgets/Widget02';
import { urlapi, token, formatNumber, CheckTokenExp } from '../../config';
import moment from 'moment';
import * as XLSX from "xlsx";

class Follow extends Component {
    constructor(props) {
        super(props);

        this.RequestFollowInfo = this.RequestFollowInfo.bind(this);
        this.RequestTotalCountFollow = this.RequestTotalCountFollow.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onChangeinput = this.onChangeinput.bind(this);
        this.onChangeSelectstatus = this.onChangeSelectstatus.bind(this);
        this.export = this.export.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.state = {
            mobile: "",
            status: null,
            followlist: [],
            minpage: 1,
            pagesize: 10,
            current: 1,
            totalpage: 0,
            totalNumber: 0,
            totalFriends: 0,
            totalBlock: 0,
            totalNone: 0,
            totalUnverified: 0,
            tableloading: false,
            loading: false,
        }
    }

    componentDidMount() {
        this.RequestFollowInfo(1, this.state.pagesize);
        this.RequestTotalCountFollow();
    }

    //==== Request FollowInfo ====
    RequestFollowInfo(startdata, enddata) {
        if (!CheckTokenExp()) {
            this.setState({ tableloading: true })
            let req = JSON.stringify({
                mobile: this.state.mobile,
                status: this.state.status,
                startData: startdata,
                endData: enddata
            });
            fetch(urlapi + "api/requestFollow", {
                method: 'post',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
                body: req
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({ totalpage: json.totalpage, followlist: json.data });
                                this.setState({ currentpage: startdata == 1 ? 1 : this.state.currentpage });
                                this.setState({ tableloading: false });
                            }.bind(this)
                        );
                    } else {
                        this.setState({ tableloading: false });
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ tableloading: false });
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    //==== Request FollowInfo ====
    RequestTotalCountFollow() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true })
            fetch(urlapi + "api/requestTotalCountFollow", {
                method: 'get',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({
                                    totalNumber: formatNumber(json.totalNumber),
                                    totalFriends: formatNumber(json.totalFriends),
                                    totalBlock: formatNumber(json.totalBlock),
                                    totalNone: formatNumber(json.totalNone),
                                    totalUnverified: formatNumber(json.totalUnverified)
                                })
                                this.setState({ loading: false });
                            }.bind(this)
                        );
                    } else {
                        this.setState({ loading: false });
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ loading: false });
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    export() {
        if (!CheckTokenExp()) {
            let req = JSON.stringify({
                mobile: this.state.mobile,
                status: this.state.status
            });

            fetch(urlapi + "api/exportFollow/", {
                method: "POST",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token,
                },
                body: req
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                const worksheet = XLSX.utils.json_to_sheet(json);
                                const workbook = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

                                XLSX.writeFile(workbook, `${moment(new Date()).format("DD/MM/YYYY")}_Friends.xlsx`);
                            }.bind(this)
                        );
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ loading: false });
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }

    }

    onSearch() {
        this.RequestFollowInfo(1, this.state.pagesize)
    }

    onChangePage(currentPage, pageSize) {
        var enddata = currentPage * pageSize;
        var startdata = ((currentPage * pageSize) + 1) - pageSize;
        this.setState({ currentpage: currentPage, pagesize: pageSize });

        this.RequestFollowInfo(startdata, enddata)
    }

    onChangeinput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    onChangeSelectstatus(value) {
        this.setState({ status: value });
    }

    render() {
        const columns = [
            {
                title: 'Mobile',
                dataIndex: 'phoneno',
                key: 'phoneno',
                width: '15%',
            },
            {
                title: 'Status',
                dataIndex: 'lnS_FOLLOW_STATUS',
                key: 'lnS_FOLLOW_STATUS',
                width: '10%',
                render: tags => (
                    <Tag style={{ textAlign: 'center' }}
                        className={
                            tags == "Friend" ? "tag-friend" :
                                tags == "Block" ? "tag-inProgres" :
                                    tags == "None" ? "tag-draft" :
                                        tags == "Unverified" ? "tag-unverified" : ""

                        }>
                        {tags}
                    </Tag>
                ),
            },
            {
                title: 'Hash Phone Number',
                dataIndex: 'hashphoneno',
                key: 'hashphoneno',
                width: '35%',
            }
        ];
        const data = this.state.followlist;
        const { Option } = Select;

        return (
            <div>
                <PageHeader title="Friends">
                    <Row gutter={16}>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <Spin spinning={this.state.loading}>
                                <Widget02 header={this.state.totalNumber} mainText="Total Number" icon="antsicon-people" color="number" variant="1" />
                            </Spin>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <Spin spinning={this.state.loading}>
                                <Widget02 header={this.state.totalBlock} mainText="Total Block" icon="fa fa-ban" color="block" variant="1" />
                            </Spin>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <Spin spinning={this.state.loading}>
                                <Widget02 header={this.state.totalFriends} mainText="Total Friends" icon="fa fa-plus-circle" color="friend" variant="1" />
                            </Spin>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <Spin spinning={this.state.loading}>
                                <Widget02 header={this.state.totalNone} mainText="Total None" icon="fa fa-minus" color="non" variant="1" />
                            </Spin>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <Spin spinning={this.state.loading}>
                                <Widget02 header={this.state.totalUnverified} mainText="Total Unverified" icon="fa fa-question-circle" color="unverified" variant="1" />
                            </Spin>
                        </Col>
                    </Row>
                </PageHeader>
                <div className="content">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Card>
                            <CardBody>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={24} md={24} lg={20} xl={20}>
                                        <Row gutter={[16, 16]}>
                                            <Col xs={24} sm={8} md={8} lg={8} xl={10}>
                                                <Input placeholder="Mobile" name="mobile"
                                                    onChange={this.onChangeinput} value={this.state.mobile} />
                                            </Col>
                                            <Col xs={24} sm={8} md={8} lg={8} xl={10}>
                                                <Select
                                                    defaultValue={null}
                                                    name="status"
                                                    onChange={this.onChangeSelectstatus}
                                                    suffixIcon={<span className="fa fa-angle-down" />}
                                                >
                                                    <Option value={null}>Status</Option>
                                                    <Option value="follow">Friends</Option>
                                                    <Option value="unfollow">Block</Option>
                                                    <Option value="unverified">Unverified</Option>
                                                    <Option value="">None</Option>
                                                </Select>
                                            </Col>
                                            <Col xs={24} sm={4} md={4} lg={4} xl={4}>
                                                <Button icon="search" style={{ marginRight: 8, width: '100%' }}
                                                    onClick={() => this.onSearch()}
                                                >
                                                    Search
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                                        <Row gutter={16} type="flex" justify="end">
                                            {/* <Col xs={24} sm={24} md={24} lg={24} xl={24}></Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}></Col> */}
                                            <Col style={{ textAlign: 'right' }}>
                                                <Button style={{ marginRight: 8 }}
                                                    onClick={() => this.export()}
                                                >
                                                    <span className="fa fa-cloud-download"></span> &nbsp;&nbsp;
                                                    Export
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row gutter={16}>
                                    <Spin spinning={this.state.tableloading}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Table
                                                rowKey={key => key.phoneno}
                                                pagination={{
                                                    current: this.state.currentpage,
                                                    defaultPageSize: "10",
                                                    pageSizeOptions: ['10', '20', '50'],
                                                    showSizeChanger: true,
                                                    total: this.state.totalpage,
                                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${this.state.totalpage} items`,
                                                    onShowSizeChange: (currentPage, pageSize) => this.onChangePage(currentPage, pageSize),
                                                    onChange: (currentPage, pageSize) => this.onChangePage(currentPage, pageSize)
                                                }}
                                                size="middle"
                                                columns={columns}
                                                dataSource={data}
                                                className="table-ants"
                                                style={{ fontSize: 10 }}
                                            />
                                        </Col>
                                    </Spin>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>

                </div>
            </div>
        );
    }
}

export default Follow;



// WEBPACK FOOTER //
// ./src/views/Follow/Follow.js